import React, { Component } from 'react';
import { Input, Row, Col, Button, Tabs, Tree } from 'antd';
import axios from 'axios';

const { TabPane } = Tabs;

class Inspecteur extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      inputText: '',
      jsonSchema: null,
      jsonErreur: null,
      jsonAlerte: null,
      get_test: null,
    };
  }

  postDataFromAPI = (data) => {
    this.setState({ loading: true, error: null });
    axios
      .post('https://services-dev.augmenticom.fr/ws_augmenticomedi', data)
      .then((response) => {
        this.setState({
          jsonSchema: response.data.result,
          jsonErreur: response.data.error,
          jsonAlerte: response.data.warning,
          get_test: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.error('Erreur lors de la requête POST :', error);
        this.setState({ loading: false, error: error.message });
      });
  };

  loadJSONAndDisplayText = () => {
    const dataToSend = this.state.inputText;
    let formattedData = dataToSend.replace(/[\r\n]+/g, '');
    formattedData = { donnees: formattedData };
    this.postDataFromAPI(formattedData);
  };

  renderJSON = (json, level = 0, path = []) => {
    if (typeof json !== 'object' || json === null) {
      return [];
    }

    let entries = Object.entries(json);

    return entries.flatMap(([key, value], index) => {
      const isNumericKey = /^\d+$/.test(key);

      if (isNumericKey && typeof value === 'object' && value !== null) {
        return this.renderJSON(value, level, path);
      }

      const newKey = [...path, key].join('-');
      const currentPath = [...path, key];
      const title =
        typeof value === 'object'
          ? key
          : `${key}: ${value}`;

      if (typeof value === 'object') {
        return {
          title,
          key: newKey,
          path: currentPath,
          children: this.renderJSON(value, level + 1, currentPath),
        };
      }

      return {
        title,
        key: newKey,
        path: currentPath,
      };
    });
  };

  render() {
    const {
      loading,
      error,
      jsonSchema,
      inputText,
    } = this.state;

    const treeData = this.renderJSON(jsonSchema);

    return (
      <div className="ant-card ant-card-bordered ant-card-type-inner">
        <Row gutter={16}>
          <Col span={12}>
            <h1>Entrez du texte :</h1>
            <Input.TextArea
              rows={20}
              style={{ width: '100%' }}
              value={inputText}
              onChange={(e) =>
                this.setState({
                  inputText: e.target.value,
                })
              }
            />
            <Button
              type="primary"
              onClick={this.loadJSONAndDisplayText}
              style={{ marginTop: 8 }}
            >
              Charger le fichier
            </Button>
          </Col>
          <Col span={12}>
            <h2>Données extraites :</h2>
            <Tabs defaultActiveKey="1">
              <TabPane tab="Traduction" key="1">
                <div className="ant-card">
                  {loading ? (
                    <div>Chargement en cours...</div>
                  ) : error ? (
                    <div>Erreur : {error}</div>
                  ) : jsonSchema ? (
                    <Tree treeData={treeData} />
                  ) : null}
                </div>
              </TabPane>
              <TabPane tab="Erreur" key="2">
                <div>
                  <h1>Erreur :</h1>
                  <pre>
                    {JSON.stringify(
                      this.state.jsonErreur,
                      null,
                      2
                    )}
                  </pre>
                </div>
              </TabPane>
              <TabPane tab="Avertissement" key="3">
                <div>
                  <h1>Avertissement :</h1>
                  <pre>
                    {JSON.stringify(
                      this.state.jsonAlerte,
                      null,
                      2
                    )}
                  </pre>
                </div>
              </TabPane>
              <TabPane tab="JSON reçu" key="4">
                <div>
                  <h1>Contenu JSON reçu :</h1>
                  <pre>
                    {JSON.stringify(
                      this.state.get_test,
                      null,
                      2
                    )}
                  </pre>
                </div>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Inspecteur;
